export default __webpack_public_path__ + "static/media/subcategory_car_3.59ca5a58.png";